import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import SupplierService from "services/Setup/Supplier/SupplierService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  supplierSliceList: [],
  response: [],
  subSupplerList: [],
  supplierEmployeeList: [],
  getCount: 0,
  SupplierProvince: 0,
  SupplierCity: "",
  SupplierKecamatan: "",
  SupplierZipCode: "",
  SupplierKelurahan: "",
  NPWPSupplierProvince: 0,
  NPWPSupplierCity: "",
  NPWPSupplierKecamatan: "",
  NPWPSupplierKelurahan: "",
  NPWPSupplierZipCode: "",
  StatusSupplier: "",
  SupplierCategory: "",
  SupplierGroupId: "",
  SupplierGroupCode: "",
};

export const getSupplerItemSerch = createAsyncThunk(
  "supplierSlice/getSupplerItemSerch",
  async (data, { rejectWithValue }) => {
    const response = await SupplierService.getSupplerItemSerch(data);
    if (response) {
      return response.data;
    } else {
      console.log("errorresponsegetSupplerItemSerch");
      return { data: "None" };
    }
  }
);

export const getSupplierEmployeeSlice = createAsyncThunk(
  "supplierSlice/getSupplierEmployeeSlice",
  async (data, { rejectWithValue }) => {
    const response = await SupplierService.getSupplierEmployeeService(data);
    if (response) {
      return response.data;
    } else {
      console.log("errorresponsegetSupplerItemSerch");
      return { data: "None" };
    }
  }
);

export const addtSuppler = createAsyncThunk(
  "supplierSlice/addtSuppler",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ datasupplierSlice:", data);
    try {
      const response = await SupplierService.addSupplier(data);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        // Handle responses other than 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      // Handle network errors or request failures
      notification.error({
        message: "Request Failed",
        description: error.response?.data?.message || "Catched error!",
        duration: 3,
      });
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getSupplerItem = createAsyncThunk(
  "supplierSlice/getSupplerItem",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ data:", data);
    // console.log("🚀 ~ responsegetSupplerItem---:");
    const response = await SupplierService.getSupplerItem(data, {
      rejectWithValue,
    }); 
    if (response) {
      return response.data;
    } else {
      console.log("errorresponsegetSupplerApproval");
      return { data: "None" };
    }
  }
);

export const getSupplerApproval = createAsyncThunk(
  "supplierSlice/getSupplerApproval",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ responsegetSupplerApproval---:");
    const response = await SupplierService.getSupplerApproval(data, {
      rejectWithValue,
    });
    if (response) {
      return response.data;
    } else {
      console.log("errorresponsegetSupplerApproval");
      return { data: "None" };
    }
  }
);

export const supplierReturn = createAsyncThunk(
  "supplierSlice/supplierReturn",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ supplierReturndata:", data);
    try {
      const response = await SupplierService.supplierReturn(data);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const supplierReject = createAsyncThunk(
  "supplierSlice/supplierReject",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ supplierRejectdata:", data);
    try {
      const response = await SupplierService.supplierReject(data);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const SupplierRequest = createAsyncThunk(
  "supplierSlice/SupplierRequest",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ SupplierRequestdata:", data);
    try {
      const response = await SupplierService.SupplierRequest(data);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const SupplerApproval = createAsyncThunk(
  "supplierSlice/SupplerApproval",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SupplierService.SupplerApproval(data);
      console.log("SupplerApproval", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const deleteSupplier = createAsyncThunk(
  "supplierSlice/deleteSupplier",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SupplierService.deleteSupplier(data);
      console.log("deleteSupplier", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);
export const supplierSlice = createSlice({
  name: "supplierSlice",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    falseMessage: (state) => {
      state.message = "";
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    SetSupplierProvince: (state, action) => {
      state.SupplierProvince = action.payload;
    },
    SetSupplierCity: (state, action) => {
      state.SupplierCity = action.payload;
    },
    SetSupplierKecamatan: (state, action) => {
      state.SupplierKecamatan = action.payload;
    },
    SetSupplierZipCode: (state, action) => {
      state.SupplierZipCode = action.payload;
    },
    SetSupplierKelurahan: (state, action) => {
      state.SupplierKelurahan = action.payload;
    },

    SetNPWPSupplierProvince: (state, action) => {
      state.NPWPSupplierProvince = action.payload;
    },
    SetNPWPSupplierCity: (state, action) => {
      state.NPWPSupplierCity = action.payload;
    },
    SetNPWPSupplierKecamatan: (state, action) => {
      state.NPWPSupplierKecamatan = action.payload;
    },
    SetNPWPSupplierKelurahan: (state, action) => {
      state.NPWPSupplierKelurahan = action.payload;
    },
    SetNPWPSupplierZipCode: (state, action) => {
      state.NPWPSupplierZipCode = action.payload;
    },
    SetStatusSupplier: (state, action) => {
      state.StatusSupplier = action.payload;
    },
    SetSupplierCategory: (state, action) => {
      state.SupplierCategory = action.payload;
    },
    SetSupplierGroupId: (state, action) => {
      state.SupplierGroupId = action.payload;
    },
    SetSupplierGroupCode: (state, action) => {
      console.log("🚀 ~ actionSetSupplierGroupCode:", action);
      state.SupplierGroupCode = action.payload;
    },
    SetResetValue: (state, action) => {
      state.SupplierProvince = 0;
      state.SupplierCity = "";
      state.SupplierKecamatan = "";
      state.SupplierZipCode = "";
      state.SupplierKelurahan = "";
      state.NPWPSupplierProvince = 0;
      state.NPWPSupplierCity = "";
      state.NPWPSupplierKecamatan = "";
      state.NPWPSupplierKelurahan = "";
      state.NPWPSupplierZipCode = "";
      state.StatusSupplier = "";
      state.SupplierCategory = "";
      state.SupplierGroupId = "";
      state.SupplierGroupCode = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // get supplier item
      .addCase(getSupplerItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSupplerItem.fulfilled, (state, action) => {
        // console.log(
        //   "🚀 ~ .addCasegetSupplerItem ~ action:",
        //   action.payload.count
        // );
        state.loading = false;
        state.subSupplerList = action.payload.data;
        state.getCount = action.payload.count;
      })
      .addCase(getSupplerItem.rejected, (state, action) => {
        state.loading = false;
        state.response = action.payload;
        state.showMessage = true;
      })
      // get supplier item
      .addCase(getSupplierEmployeeSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSupplierEmployeeSlice.fulfilled, (state, action) => {
        console.log(
          "🚀 ~ .addCasegetSupplierEmployeeSlice ~ action:",
          action.payload
        );
        state.loading = false;
        state.supplierEmployeeList = action.payload.data;
        state.getCount = action.payload.count;
      })
      .addCase(getSupplierEmployeeSlice.rejected, (state, action) => {
        state.loading = false;
        state.response = action.payload;
        state.showMessage = true;
      })
      // get supplier item
      .addCase(getSupplerItemSerch.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSupplerItemSerch.fulfilled, (state, action) => {
        // console.log(
        //   "🚀 ~ .addCasegetSupplerItemSerch ~ action:",
        //   action.payload.count
        // );
        state.loading = false;
        state.subSupplerList = action.payload.data;
        state.getCount = action.payload.count;
      })
      .addCase(getSupplerItemSerch.rejected, (state, action) => {
        state.loading = false;
        state.response = action.payload;
        state.showMessage = true;
      })
      // Get supplier approval
      .addCase(getSupplerApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSupplerApproval.fulfilled, (state, action) => {
        state.loading = false;
        state.subSupplerList = action.payload.data;
        state.getCount = action.payload.count;
      })
      .addCase(getSupplerApproval.rejected, (state, action) => {
        state.loading = false;
        state.response = action.payload;
        state.showMessage = true;
      })
      //Add Supplier
      .addCase(addtSuppler.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(addtSuppler.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(addtSuppler.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Do Return
      .addCase(supplierReturn.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(supplierReturn.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(supplierReturn.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Do Return
      .addCase(supplierReject.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(supplierReject.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(supplierReject.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Do Request
      .addCase(SupplierRequest.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(SupplierRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(SupplierRequest.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  showLoading,
  falseMessage,
  showNotification,
  hideNotification,
  SetSupplierProvince,
  SetSupplierCity,
  SetSupplierKecamatan,
  SetSupplierZipCode,
  SetSupplierKelurahan,
  SetNPWPSupplierProvince,
  SetNPWPSupplierCity,
  SetNPWPSupplierKecamatan,
  SetNPWPSupplierKelurahan,
  SetNPWPSupplierZipCode,
  SetStatusSupplier,
  SetSupplierCategory,
  SetSupplierGroupId,
  SetSupplierGroupCode,
  SetResetValue,
} = supplierSlice.actions;

export default supplierSlice.reducer;
